import { IOperation } from './i-operation';
import { BaseArticlesSequenceOperation } from './base-articles-sequence-operation';

export class UndoAttachArticlesOperation extends BaseArticlesSequenceOperation implements IOperation {
  public getQualifiedClassName(): string {
    return 'UndoAttachArticlesOperation';
  }

  public async performRedo(): Promise<void> {
    await this.attachArticles();
  }

  public async performUndo(): Promise<void> {
    await this.detachArticles();
  }

  public getOperationDescription(): string {
    return '';
  }
}
